/* eslint-disable eqeqeq */
import React, { useCallback, useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { useLocation, useNavigate } from "react-router-dom";
import {
  API,
  defaultLimitPagination,
  deleteCall,
  fileUpload,
  get,
  TableClasses,
  TableWrapClasses,
  TDClasses,
  THClasses,
  TRClasses,
} from "../../config";
import Pagination from "../../components/Pagination";
import { formatNumber } from "../../lib/Misc";
import MainBody from "../../components/MainBody/MainBody";
import { CalendarDatePicker } from "../../components/CalendarDatePicker";
import { AnimatedTooltip } from "../../components/AnimatedTooltip";
import { Button } from "../../components/ui/button";
import {
  CheckCircle2Icon,
  Download,
  LucidePlusCircle,
  RefreshCcw,
} from "lucide-react";
import moment from "moment";
import CustomTooltip from "../../components/CustomTooltip";
import Confirmation from "../../components/Confirmation";
import sortCaret from "../../components/SortCaret";
import { ResponsiveDrawerForm } from "../../components/ResponsiveDrawerForm";
import AddTransaction from "./AddTransaction";
import UploadBankTransaction from "./UploadBankTransaction";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { Label } from "../../components/ui/label";
import CustomLabelText from "../../components/CustomLabelText";
import UnauthorisedAccess from "../../UnauthorisedAccess";
import DropDownButton from "../../components/DropDownButton";
// Here id => VenderId
const BankTransactions = ({
  selectedDateRange,
  setSelectedDateRange,
  trustId,
  isDesktop,
  readAccess,
  writeAccess,
}) => {
  const [refreshSelectedDateRange, setRefreshSelectedDateRange] =
    useState(selectedDateRange);
  const navigate = useNavigate();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const defaultPage = query.get("page");
  const defaultLimit = query.get("limit");
  const [loading, setLoading] = useState(false);
  const [bankTransactionData, setBankTransactionData] = useState([]);
  const [page, setPage] = useState(defaultPage || 1);
  const [limit, setLimit] = useState(defaultLimit || defaultLimitPagination);
  const [total, setTotal] = useState();
  const [from, setFrom] = useState();
  const [to, setTo] = useState();
  const [sortField, setSortField] = useState();
  const [sortOrder, setSortOrder] = useState();

  const [showDelete, setShowDelete] = useState(false);
  const [showDeleteAll, setShowDeleteAll] = useState(false);
  const [itemId, setItemId] = useState();
  const [showAddTransaction, setShowAddTransaction] = useState(false);

  const [showRefreshModal, setShowRefreshModal] = useState(false);
  const [selectedRowIds, setSelectedRowIds] = useState([]);
  const [notSelectedRowIds, setNotSelectedRowIds] = useState([]);

  const toggleRefreshModal = () => {
    if (showRefreshModal) {
      setRefreshSelectedDateRange(selectedDateRange);
    }
    setShowRefreshModal(!showRefreshModal);
  };

  const toggleDeleteModal = () => {
    setShowDelete(!showDelete);
  };

  const toggleDeleteAllModal = () => {
    setShowDeleteAll(!showDeleteAll);
  };

  const toggleShowAddTransaction = () => {
    setShowAddTransaction(!showAddTransaction);
  };

  var today = new Date();
  today.setHours(0, 0, 0, 0);

  // *API Call for Geting Assets - Start

  const fetchBankTransactions = useCallback(
    async (passLimit, passPage) => {
      try {
        setLoading(true);
        const { data } = await get(
          `${API.BANK_TRANSACTION_LIST}?start_date=${
            moment(selectedDateRange?.from).format("DD-MM-YYYY")
              ? moment(selectedDateRange?.from).format("DD-MM-YYYY")
              : ""
          }&end_date=${
            moment(selectedDateRange?.to).format("DD-MM-YYYY")
              ? moment(selectedDateRange?.to).format("DD-MM-YYYY")
              : ""
          }&limit=${
            passLimit ? passLimit : limit ? limit : defaultLimitPagination
          }&page=${passPage ? passPage : page ? page : 1}&trust_id=${
            trustId ? trustId : ""
          }&sort_column=${sortField ? sortField : ""}&sort_order=${
            sortOrder ? sortOrder : ""
          }`,
        );
        setLimit(data?.data?.per_page);
        setPage(data?.data?.current_page);
        setTotal(data?.data?.total);
        setFrom(data?.data?.from);
        setTo(data?.data?.to);
        let transactionData = data?.data?.data;
        const notSelected = [];
        for (let i = 0; i < transactionData?.length; i++) {
          if (
            transactionData[i]?.deleted_at ||
            transactionData[i]?.bank_reconciled_status == 1
          ) {
            notSelected.push(transactionData[i]?.id);
          }
        }
        setNotSelectedRowIds(notSelected);
        setBankTransactionData(data?.data?.data);
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      selectedDateRange?.from,
      selectedDateRange?.to,
      sortField,
      sortOrder,
      trustId,
    ],
  );

  // *API Call for Geting Assets - End

  const bankTransactionGenerator = (quantity) => {
    const items = [];
    for (let i = 0; i < quantity; i++) {
      items.push({
        key: bankTransactionData[i]?.id,
        transaction_date: bankTransactionData[i]?.transaction_date
          ? moment(
              bankTransactionData[i]?.transaction_date,
              "DD-MM-YYYY",
            ).format("DD-MM-YYYY")
          : "-",
        project_name: bankTransactionData[i]?.builder_project?.project_name
          ? bankTransactionData[i]?.builder_project?.project_name
          : "-",
        description: bankTransactionData[i]?.description
          ? bankTransactionData[i]?.description
          : "-",
        credit:
          bankTransactionData[i]?.base_type === 1 ? (
            <span className="rag-green">
              {"$" + formatNumber(Number(bankTransactionData[i]?.amount))}
            </span>
          ) : (
            "-"
          ),
        debit:
          bankTransactionData[i]?.base_type === 0 ? (
            <span className="rag-red">
              {"$" + formatNumber(Number(bankTransactionData[i]?.amount))}
            </span>
          ) : (
            "-"
          ),
        bank_transaction_source: bankTransactionData[i]?.source
          ? bankTransactionData[i]?.source
          : "-",
        action: bankTransactionData[i]?.deleted_at ? (
          ""
        ) : bankTransactionData[i]?.bank_reconciled_status != 1 ? (
          <span className="flex items-center gap-2 justify-center">
            <CustomTooltip message={"Delete"}>
              <span>
                <FontAwesomeIcon
                  onClick={() => {
                    setItemId(bankTransactionData[i]?.id);
                    toggleDeleteModal();
                  }}
                  icon={faTrash}
                  size="1x"
                  data-toggle="modal"
                  data-target="#clientDetail"
                />
              </span>
            </CustomTooltip>
          </span>
        ) : (
          <span className="flex items-center gap-2 justify-center">
            <CustomTooltip message={"Reconciled"}>
              <CheckCircle2Icon className="text-green-500" size={22} />
            </CustomTooltip>
          </span>
        ),
        archived: bankTransactionData[i]?.deleted_at ? (
          <CustomTooltip message={"Archived"}>
            <span>
              <span color={"red"} key={"red"}>
                {String.fromCodePoint("0x0001F6AB")}
              </span>
            </span>
          </CustomTooltip>
        ) : (
          ""
        ),
      });
    }
    return items;
  };

  const bankTransactions = bankTransactionGenerator(
    bankTransactionData?.length,
  );

  const columns = [
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "transaction_date",
      text: "Date",
      sort: true,
      sortCaret,
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "description",
      text: "Description",
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "credit",
      text: "Credit",

      sort: true,
      sortCaret,
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "debit",
      text: "Debit",

      sort: true,
      sortCaret,
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "bank_transaction_source",
      text: "Bank Transaction Source",
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "action",
      text: "Action",
      className: "text-center",
      headerStyle: { textAlign: "center" },
      style: { width: "127px", textAlign: "center" },
    },
  ];

  const handleTableChange = (type, { page, sortField, sortOrder }) => {
    if (type === "sort") {
      setPage(1);
      setSortField(sortField);
      setSortOrder(
        sortOrder === "asc" ? "ASC" : sortOrder === "desc" && "DESC",
      );
    }
  };

  useEffect(() => {
    fetchBankTransactions();
  }, [fetchBankTransactions]);

  const handleUpdateLimit = (e) => {
    const limit = e.target.value;
    setLimit(limit);
    setPage(1);
    fetchBankTransactions(limit, 1);
  };

  const handleChangePage = (page) => {
    setPage(page);
    fetchBankTransactions(limit, page);
  };
  // *Assets Table Row and Column Generation, Filtering and Sorting of Record - End

  useEffect(() => {
    navigate(
      `?tab=bank-transactions&limit=${
        limit ? limit : defaultLimitPagination
      }&page=${page ? page : 1}&sort_column=${
        sortField ? sortField : ""
      }&sort_order=${sortOrder ? sortOrder : ""}`,
      {
        replace: true,
      },
    );
  }, [navigate, limit, page, sortField, sortOrder]);

  const handleExport = useCallback(
    async (format) => {
      try {
        setLoading(true);
        const { data } = await get(
          `${API.BANK_TRANSACTION_LIST}?start_date=${
            moment(selectedDateRange?.from).format("DD-MM-YYYY")
              ? moment(selectedDateRange?.from).format("DD-MM-YYYY")
              : ""
          }&end_date=${
            moment(selectedDateRange?.to).format("DD-MM-YYYY")
              ? moment(selectedDateRange?.to).format("DD-MM-YYYY")
              : ""
          }&trust_id=${trustId ? trustId : ""}&format=${
            format ? format : ""
          }&export=1`,
        );
        const export_report_path = data?.data?.file;
        setLoading(false);
        if (export_report_path) {
          var a = document.createElement("a");
          a.href = export_report_path;
          var file = export_report_path.split("/");
          a.setAttribute(
            "download",
            file[file.length - 1] || "bank_transaction.pdf",
          );
          a.setAttribute("target", "_blank");
          document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
          a.click();
          a.remove();
          setLoading(false);
        }
      } catch (e) {
        setLoading(false);
      }
    },
    [selectedDateRange?.from, selectedDateRange?.to, trustId],
  );

  const handleSingleDelete = async () => {
    try {
      setLoading(true);
      await deleteCall(`${API.TRANSACTION_DELETE}/${itemId}`);
      setLoading(false);
      fetchBankTransactions(limit, page);
      toggleDeleteModal();
    } catch (e) {
      setLoading(false);
      return null;
    }
  };

  const handleBulkDelete = async () => {
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("trust_id", trustId);
      for (let i = 0; i < selectedRowIds?.length; i++) {
        formData.append(`bank_transaction_ids[${i}]`, selectedRowIds[i]);
      }
      await fileUpload(`${API.TRANSACTION_DELETE_BULK}`, formData);
      setLoading(false);
      fetchBankTransactions(limit, page);
      toggleDeleteAllModal();
    } catch (e) {
      setLoading(false);
      return null;
    }
  };

  const handleRefresh = async () => {
    try {
      setLoading(true);
      await get(
        `${API.REFRESH_BANK_TRANSACTION}?start_date=${
          moment(refreshSelectedDateRange?.from).format("DD-MM-YYYY")
            ? moment(refreshSelectedDateRange?.from).format("DD-MM-YYYY")
            : ""
        }&end_date=${
          moment(refreshSelectedDateRange?.to).format("DD-MM-YYYY")
            ? moment(refreshSelectedDateRange?.to).format("DD-MM-YYYY")
            : ""
        }&trust_id=${trustId}`,
      );
      setLoading(false);
      fetchBankTransactions(limit, page);
      toggleRefreshModal();
    } catch (e) {
      setLoading(false);
      return null;
    }
  };

  const arrayRemove = (arr, value) => {
    return arr.filter(function (ele) {
      return ele !== value;
    });
  };

  const selectRow = {
    mode: "checkbox",
    clickToSelect: false,
    selected: selectedRowIds,
    nonSelectable: notSelectedRowIds,
    onSelectAll: (row, isSelect) => {
      if (bankTransactionData?.length > 0) {
        if (row) {
          const ids =
            isSelect &&
            isSelect?.length > 0 &&
            isSelect?.map((item) => {
              return item?.key;
            });
          setSelectedRowIds(selectedRowIds ? selectedRowIds.concat(ids) : ids);
        } else {
          const removableData =
            isSelect &&
            isSelect?.length > 0 &&
            isSelect.map(function (data) {
              return data?.key;
            });
          setSelectedRowIds(
            selectedRowIds
              ? selectedRowIds.filter((item) => !removableData.includes(item))
              : [],
          );
        }
      }
    },
    onSelect: (row, isSelect) => {
      if (isSelect) {
        setSelectedRowIds((keys) => [...keys, row?.key]);
      } else {
        setSelectedRowIds(arrayRemove(selectedRowIds, row?.key));
      }
    },
  };

  return readAccess ? (
    <>
      <div className="relative">
        <MainBody
          search={false}
          innerBody={true}
          actionAlign={"end"}
          parentHeight={true}
          actionContent={
            <>
              {" "}
              <div className="flex items-center gap-2">
                <CalendarDatePicker
                  date={selectedDateRange}
                  onDateSelect={setSelectedDateRange}
                  variant="outline"
                  align={isDesktop ? "end" : "start"}
                  disabledDate={(date) => date > new Date()}
                />
                <UploadBankTransaction
                  fetchAccountData={() => fetchBankTransactions(limit, page)}
                  trustId={trustId}
                  ButtonName={"Import"}
                  setLoading={setLoading}
                />
                <AnimatedTooltip title={"Archive"} bottomAlign>
                  <Button
                    onClick={() => toggleDeleteAllModal()}
                    className="flex gap-2 items-center"
                    disabled={selectedRowIds?.length === 0}
                  >
                    Archive
                  </Button>
                </AnimatedTooltip>
                <AnimatedTooltip title={"Sync With Yodlee"} bottomAlign>
                  <Button
                    onClick={() => toggleRefreshModal()}
                    className="flex gap-2 items-center"
                  >
                    Fetch <RefreshCcw size={18} />
                  </Button>
                </AnimatedTooltip>

                <DropDownButton
                  items={[
                    {
                      label: "PDF",
                      onClick: () => handleExport("pdf"),
                      disabled: loading,
                    },
                    {
                      label: "Excel",
                      onClick: () => handleExport("xlsx"),
                      disabled: loading,
                    },
                  ]}
                  text={
                    <div className="flex gap-2 items-center">
                      Export <Download size={18} />
                    </div>
                  }
                />

                <ResponsiveDrawerForm
                  description={""}
                  title={"Add Transaction"}
                  handleOpen={() => {}}
                  handleClose={() => {
                    setShowAddTransaction(false);
                  }}
                  popupType={"bank-transactions"}
                  write={true}
                  buttonText={
                    <div className="flex items-center gap-1">
                      <LucidePlusCircle size={18} />
                      <span>Add Transaction</span>
                    </div>
                  }
                  className={""}
                  open={showAddTransaction}
                  buttonClassName={""}
                  setOpen={setShowAddTransaction}
                >
                  <AddTransaction
                    trustId={trustId}
                    toggleShowAddTransaction={toggleShowAddTransaction}
                    fetchBankTransactions={fetchBankTransactions}
                  />
                </ResponsiveDrawerForm>
              </div>
            </>
          }
          loading={loading}
        >
          <div className="custom-table">
            <div className={"table-body-class sm:max-h-[643px]"}>
              <BootstrapTable
                keyField="key"
                remote
                data={bankTransactions}
                columns={columns}
                selectRow={selectRow}
                onTableChange={handleTableChange}
                rowClasses={TRClasses}
                noDataIndication="No Data Found"
                classes={TableClasses}
                wrapperClasses={TableWrapClasses}
              />
            </div>

            <Pagination
              total={total}
              limit={parseInt(limit)}
              currentPage={page}
              updateLimit={handleUpdateLimit}
              updatePage={handleChangePage}
              from={from}
              to={to}
            />
            {showDelete && (
              <Confirmation
                title={"Delete Bank Transaction"}
                open={showDelete}
                setOpen={setShowDelete}
                toggleShow={() => {
                  toggleDeleteModal();
                }}
                popupType={"bank-transactions"}
                className="sm:max-w-fit"
                message={`Are your sure you want to delete this bank transaction?`}
                okAction={async () => {
                  await handleSingleDelete();
                }}
                loading={loading}
                cancelAction={() => {
                  toggleDeleteModal();
                }}
              />
            )}

            {showDeleteAll && (
              <Confirmation
                title={"Bulk Delete Bank Transaction"}
                open={showDeleteAll}
                setOpen={setShowDeleteAll}
                toggleShow={() => {
                  toggleDeleteAllModal();
                }}
                popupType={"bank-transactions"}
                className="sm:max-w-fit"
                message={`Are your sure you want to delete all bank transaction?`}
                okAction={async () => {
                  await handleBulkDelete();
                }}
                loading={loading}
                cancelAction={() => {
                  toggleDeleteAllModal();
                }}
              />
            )}

            <Confirmation
              title={"Fetch Bank Transaction"}
              open={showRefreshModal}
              setOpen={setShowRefreshModal}
              toggleShow={() => {
                toggleRefreshModal();
              }}
              popupType={"yodlee"}
              className="sm:max-w-[400px]"
              message={
                <>
                  <div className="grid gap-2">
                    <Label htmlFor="transaction_ate">
                      <CustomLabelText
                        required={true}
                        labelText="Transaction Date"
                      />
                    </Label>
                    <CalendarDatePicker
                      date={refreshSelectedDateRange}
                      onDateSelect={setRefreshSelectedDateRange}
                      variant="outline"
                      align={isDesktop ? "end" : "start"}
                    />
                  </div>
                </>
              }
              okAction={async () => {
                await handleRefresh();
              }}
              loading={loading}
              cancelAction={() => {
                toggleRefreshModal();
              }}
            />
          </div>
        </MainBody>
      </div>
    </>
  ) : (
    <UnauthorisedAccess expandList={true} popup={true} />
  );
};
export default BankTransactions;
